module.exports = __webpack_public_path__ + "static/media/11d.ced52474.svg";